var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.5,
    height: 44.5,
    viewBox: "0 0 44.5 44.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.208,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.208,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FDBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.114,
    y1: 0.089,
    x2: 0.698,
    y2: 0.845,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.389,
    y1: 0.415,
    x2: 0.846,
    y2: 0.763,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76E2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 0.42,
    x2: 0.5,
    y2: 1.346,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF9100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1.007,
    y1: 0.5,
    x2: 0.243,
    y2: 0.5,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.225,
    y1: 0.341,
    x2: 1.261,
    y2: 1.152,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#762EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E1191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.145,
    y1: 0.53,
    x2: -2.573,
    y2: -0.225,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0B799D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#096380",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#084F67",
    stopOpacity: 0.761
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13306",
    "data-name": "Group 13306",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20341",
    "data-name": "Path 20341",
    d: "M107.536,6.937H92.313V2.6a2.6,2.6,0,0,1,2.6-2.6h10.02a2.6,2.6,0,0,1,2.6,2.6Z",
    transform: "translate(-84.258 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20342",
    "data-name": "Path 20342",
    d: "M62.705,6.937H47.482V2.6a2.6,2.6,0,0,1,2.6-2.6H60.1a2.6,2.6,0,0,1,2.6,2.6Z",
    transform: "translate(-43.339 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20343",
    "data-name": "Path 20343",
    d: "M15.223,4.938V2.6a2.6,2.6,0,0,0-2.6-2.6H2.6A2.6,2.6,0,0,0,0,2.6v28.09A3.706,3.706,0,0,0,3.706,34.4H40.794A3.706,3.706,0,0,0,44.5,30.691V9.776A3.706,3.706,0,0,0,40.794,6.07H16.355a1.132,1.132,0,0,1-1.132-1.132Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13305",
    "data-name": "Group 13305",
    transform: "translate(31.976 8.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20344",
    "data-name": "Path 20344",
    d: "M368.284,99.271h-.893a.927.927,0,0,1-.927-.927v-.893a.927.927,0,0,1,.927-.927h.893a.927.927,0,0,1,.927.927v.893A.927.927,0,0,1,368.284,99.271Z",
    transform: "translate(-366.465 -96.525)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20345",
    "data-name": "Path 20345",
    d: "M408.415,99.271h-.893a.927.927,0,0,1-.927-.927v-.893a.927.927,0,0,1,.927-.927h.893a.927.927,0,0,1,.927.927v.893A.927.927,0,0,1,408.415,99.271Z",
    transform: "translate(-403.094 -96.525)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20346",
    "data-name": "Path 20346",
    d: "M448.546,99.271h-.893a.927.927,0,0,1-.927-.927v-.893a.927.927,0,0,1,.927-.927h.893a.927.927,0,0,1,.927.927v.893A.927.927,0,0,1,448.546,99.271Z",
    transform: "translate(-439.724 -96.525)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20347",
    "data-name": "Path 20347",
    d: "M0,304.771v4.1a3.706,3.706,0,0,0,3.706,3.706H40.794a3.706,3.706,0,0,0,3.706-3.706v-4.1Z",
    transform: "translate(0 -278.178)",
    fill: "url(#linear-gradient-7)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20348",
    "data-name": "Path 20348",
    d: "M156.208,188.242l-18.432-18.083a2.313,2.313,0,0,0-4.038.226l-8.806,14.179a2.646,2.646,0,0,0,.494,3.61,5.106,5.106,0,0,0,.63.55h28.324A3.688,3.688,0,0,0,156.208,188.242Z",
    transform: "translate(-113.587 -154.327)",
    fill: "url(#linear-gradient-8)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13307",
    "data-name": "Group 13307",
    transform: "translate(10.566 14.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20349",
    "data-name": "Path 20349",
    d: "M141.672,187.825h-2.586V195.7a2.2,2.2,0,0,1-2.2,2.2H129.2a2.2,2.2,0,0,1-2.2-2.2v-7.879h-3.106a2.786,2.786,0,0,1-2.361-4.267l8.893-14.179a2.786,2.786,0,0,1,4.721,0l8.893,14.179A2.786,2.786,0,0,1,141.672,187.825Z",
    transform: "translate(-121.095 -168.073)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20350",
    "data-name": "Path 20350",
    d: "M263.893,187.825h-2.586V195.7a2.2,2.2,0,0,1-2.2,2.2H255V168.073a2.764,2.764,0,0,1,2.361,1.306l8.893,14.179A2.786,2.786,0,0,1,263.893,187.825Z",
    transform: "translate(-243.316 -168.073)",
    fill: "url(#linear-gradient-10)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFolder);
export default __webpack_public_path__ + "static/media/uploadFolder.933f493656602641b208501746c9f91b.svg";
export { ForwardRef as ReactComponent };